// import React, { useState, useEffect } from 'react';
// import {
//   Box,
//   Card,
//   CardContent,
//   Typography,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Grid,
//   Alert,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Chip,
//   Button,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   TextField,
//   IconButton,
//   Tooltip,
//   Pagination,
// } from '@mui/material';
// import { Receipt, Refresh, FilterList, Download } from '@mui/icons-material';
// import apiService from '../services/apiService';

// const DriverRechargeHistoryPage = () => {
//   const [drivers, setDrivers] = useState([]);
//   const [selectedDriver, setSelectedDriver] = useState('');
//   const [driverDetails, setDriverDetails] = useState(null);
//   const [rechargeHistory, setRechargeHistory] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');
//   const [success, setSuccess] = useState('');
//   const [filterStatus, setFilterStatus] = useState('all');
//   const [dateRange, setDateRange] = useState({
//     startDate: '',
//     endDate: '',
//   });
//   const [selectedRecharge, setSelectedRecharge] = useState(null);
//   const [openDetailsDialog, setOpenDetailsDialog] = useState(false);
//   const [totalAmount, setTotalAmount] = useState(0);
//   const [filteredHistory, setFilteredHistory] = useState([]);
//   const [pagination, setPagination] = useState({
//     currentPage: 1,
//     totalPages: 0,
//     totalItems: 0,
//     itemsPerPage: 10,
//   });
//   const [page, setPage] = useState(1);

//   useEffect(() => {
//     fetchDrivers();
//   }, []);

//   useEffect(() => {
//     applyFilters();
//   }, [rechargeHistory, filterStatus, dateRange]);

//   const fetchDrivers = async () => {
//     try {
//       const response = await apiService.getDrivers({});
//       if (response.success) {
//         setDrivers(response.data || []);
//       }
//     } catch (err) {
//       console.error('Error fetching drivers:', err);
//       setError('Failed to load drivers');
//     }
//   };

//   const handleDriverSelect = async (driverId) => {
//     setSelectedDriver(driverId);
//     setError('');
//     setSuccess('');
//     setFilterStatus('all');
//     setDateRange({ startDate: '', endDate: '' });
//     setTotalAmount(0);
//     setPage(1);

//     if (!driverId) {
//       setDriverDetails(null);
//       setRechargeHistory([]);
//       setPagination({
//         currentPage: 1,
//         totalPages: 0,
//         totalItems: 0,
//         itemsPerPage: 10,
//       });
//       return;
//     }

//     try {
//       setLoading(true);
//       // Fetch driver details and recharge history
//       const [driverResponse, historyResponse] = await Promise.all([
//         apiService.getDriverDetails(driverId),
//         apiService.getDriverRechargeHistory(driverId)
//       ]);

//       if (driverResponse.success) {
//         setDriverDetails(driverResponse.data);
//       }

//       if (historyResponse.success) {
//         // Handle the nested data structure
//         const historyData = historyResponse.data?.history || [];
//         setRechargeHistory(historyData);
        
//         // Update pagination info
//         if (historyResponse.data?.pagination) {
//           setPagination(historyResponse.data.pagination);
//         }
        
//         // Calculate total recharge amount
//         const total = historyData.reduce((sum, item) => sum + parseFloat(item.amount || 0), 0);
//         setTotalAmount(total);
//       }
//     } catch (err) {
//       setError('Failed to load recharge history');
//       console.error('Error:', err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const applyFilters = () => {
//     let filtered = [...rechargeHistory];

//     // Filter by status - map 'active' to 'completed' for display
//     if (filterStatus !== 'all') {
//       const statusMap = {
//         'completed': ['active', 'completed'],
//         'pending': ['pending'],
//         'failed': ['failed'],
//         'refunded': ['refunded'],
//       };
//       const validStatuses = statusMap[filterStatus] || [];
//       filtered = filtered.filter(item => validStatuses.includes(item.status));
//     }

//     // Filter by date range
//     if (dateRange.startDate) {
//       filtered = filtered.filter(item => 
//         new Date(item.created_at) >= new Date(dateRange.startDate)
//       );
//     }
//     if (dateRange.endDate) {
//       filtered = filtered.filter(item => 
//         new Date(item.created_at) <= new Date(dateRange.endDate)
//       );
//     }

//     setFilteredHistory(filtered);
//   };

//   const handleRefresh = () => {
//     if (selectedDriver) {
//       handleDriverSelect(selectedDriver);
//       setSuccess('Refreshed successfully');
//       setTimeout(() => setSuccess(''), 3000);
//     }
//   };

//   const handleViewDetails = (recharge) => {
//     setSelectedRecharge(recharge);
//     setOpenDetailsDialog(true);
//   };

//   const handleCloseDetailsDialog = () => {
//     setOpenDetailsDialog(false);
//     setSelectedRecharge(null);
//   };

//   const handlePageChange = (event, value) => {
//     setPage(value);
//     // If you have paginated API, call it here
//     // fetchRechargeHistory(selectedDriver, value);
//   };

//   const handleDownloadReport = () => {
//     // Create CSV report
//     const headers = ['Date', 'Amount', 'Plan Type', 'Status', 'Start Date', 'End Date'];
//     const rows = filteredHistory.map(item => [
//       new Date(item.created_at).toLocaleString(),
//       `₹${parseFloat(item.amount || 0).toFixed(2)}`,
//       item.plan_type || 'N/A',
//       item.status,
//       new Date(item.start_date).toLocaleDateString(),
//       new Date(item.end_date).toLocaleDateString(),
//     ]);

//     const csvContent = [
//       headers.join(','),
//       ...rows.map(row => row.join(','))
//     ].join('\n');

//     const blob = new Blob([csvContent], { type: 'text/csv' });
//     const url = window.URL.createObjectURL(blob);
//     const link = document.createElement('a');
//     link.href = url;
//     link.download = `recharge_history_${selectedDriver}_${new Date().toISOString().split('T')[0]}.csv`;
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//     window.URL.revokeObjectURL(url);
//   };

//   const getStatusChip = (status) => {
//     const statusConfig = {
//       active: { label: 'Active', color: 'success' },
//       completed: { label: 'Completed', color: 'success' },
//       pending: { label: 'Pending', color: 'warning' },
//       failed: { label: 'Failed', color: 'error' },
//       refunded: { label: 'Refunded', color: 'info' },
//       expired: { label: 'Expired', color: 'default' },
//     };
//     const config = statusConfig[status] || statusConfig.pending;
//     return <Chip label={config.label} color={config.color} size="small" />;
//   };

//   const getPlanTypeLabel = (planType) => {
//     const planMap = {
//       'admin_assigned_180d': 'Admin Assigned (180 Days)',
//       'admin_assigned_90d': 'Admin Assigned (90 Days)',
//       'admin_assigned_30d': 'Admin Assigned (30 Days)',
//       'daily': 'Daily Plan',
//       'weekly': 'Weekly Plan',
//       'monthly': 'Monthly Plan',
//     };
//     return planMap[planType] || planType || 'N/A';
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return 'N/A';
//     return new Date(dateString).toLocaleDateString('en-IN', {
//       day: '2-digit',
//       month: '2-digit',
//       year: 'numeric',
//     });
//   };

//   const formatCurrency = (amount) => {
//     const num = parseFloat(amount || 0);
//     return `₹${num.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
//   };

//   return (
//     <Box>
//       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
//         <Box>
//           <Typography variant="h4" fontWeight="bold" gutterBottom>
//             Driver Recharge History
//           </Typography>
//           <Typography variant="body2" color="text.secondary">
//             Select a driver to view their recharge history and transaction details
//           </Typography>
//         </Box>
//         {selectedDriver && (
//           <Tooltip title="Refresh History">
//             <IconButton onClick={handleRefresh} color="primary">
//               <Refresh />
//             </IconButton>
//           </Tooltip>
//         )}
//       </Box>

//       {error && (
//         <Alert severity="error" sx={{ mb: 3 }} onClose={() => setError('')}>
//           {error}
//         </Alert>
//       )}

//       {success && (
//         <Alert severity="success" sx={{ mb: 3 }} onClose={() => setSuccess('')}>
//           {success}
//         </Alert>
//       )}

//       <Grid container spacing={3}>
//         {/* Driver Selection Card */}
//         <Grid item xs={12} md={4}>
//           <Card>
//             <CardContent>
//               <Typography variant="h6" gutterBottom>
//                 Select Driver
//               </Typography>

//               <FormControl fullWidth sx={{ mt: 2 }}>
//                 <InputLabel>Driver</InputLabel>
//                 <Select
//                   value={selectedDriver}
//                   onChange={(e) => handleDriverSelect(e.target.value)}
//                   label="Driver"
//                 >
//                   <MenuItem value="">
//                     <em>Select a driver</em>
//                   </MenuItem>
//                   {drivers.map((driver) => (
//                     <MenuItem key={driver.id} value={driver.id}>
//                       {driver.name} - {driver.phone}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>

//               {driverDetails && (
//                 <Box sx={{ mt: 3 }}>
//                   <Typography variant="subtitle2" color="text.secondary">
//                     Driver Details
//                   </Typography>
//                   <Typography variant="body2" sx={{ mt: 1 }}>
//                     <strong>Name:</strong> {driverDetails.name}
//                   </Typography>
//                   <Typography variant="body2">
//                     <strong>Phone:</strong> {driverDetails.phone}
//                   </Typography>
//                   <Typography variant="body2">
//                     <strong>Email:</strong> {driverDetails.email || 'N/A'}
//                   </Typography>
//                   <Typography variant="body2">
//                     <strong>Status:</strong>{' '}
//                     <Chip label={driverDetails.status} size="small" />
//                   </Typography>
//                 </Box>
//               )}
//             </CardContent>
//           </Card>

//           {/* Summary Card */}
//           {selectedDriver && rechargeHistory.length > 0 && (
//             <Card sx={{ mt: 3 }}>
//               <CardContent>
//                 <Typography variant="h6" gutterBottom>
//                   Summary
//                 </Typography>
//                 <Box sx={{ mt: 2 }}>
//                   <Typography variant="body2">
//                     <strong>Total Recharges:</strong> {rechargeHistory.length}
//                   </Typography>
//                   <Typography variant="body2">
//                     <strong>Total Amount:</strong> {formatCurrency(totalAmount)}
//                   </Typography>
//                   <Typography variant="body2">
//                     <strong>Filtered Count:</strong> {filteredHistory.length}
//                   </Typography>
//                   <Typography variant="body2">
//                     <strong>Filtered Amount:</strong>{' '}
//                     {formatCurrency(
//                       filteredHistory.reduce((sum, item) => sum + parseFloat(item.amount || 0), 0)
//                     )}
//                   </Typography>
//                   {pagination.totalItems > 0 && (
//                     <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
//                       Showing {pagination.itemsPerPage} of {pagination.totalItems} records
//                     </Typography>
//                   )}
//                 </Box>
//               </CardContent>
//             </Card>
//           )}
//         </Grid>

//         {/* History List */}
//         <Grid item xs={12} md={8}>
//           <Card>
//             <CardContent>
//               <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
//                 <Typography variant="h6">
//                   Recharge History
//                   {selectedDriver && (
//                     <Typography component="span" variant="body2" color="text.secondary" sx={{ ml: 1 }}>
//                       ({filteredHistory.length} records)
//                     </Typography>
//                   )}
//                 </Typography>
//                 {filteredHistory.length > 0 && (
//                   <Button
//                     size="small"
//                     startIcon={<Download />}
//                     onClick={handleDownloadReport}
//                     sx={{ color: '#000' }}
//                   >
//                     Export CSV
//                   </Button>
//                 )}
//               </Box>

//               {/* Filters */}
//               {selectedDriver && rechargeHistory.length > 0 && (
//                 <Grid container spacing={2} sx={{ mb: 2 }}>
//                   <Grid item xs={12} sm={4}>
//                     <FormControl fullWidth size="small">
//                       <InputLabel>Status Filter</InputLabel>
//                       <Select
//                         value={filterStatus}
//                         onChange={(e) => setFilterStatus(e.target.value)}
//                         label="Status Filter"
//                       >
//                         <MenuItem value="all">All Status</MenuItem>
//                         <MenuItem value="active">Active</MenuItem>
//                         <MenuItem value="pending">Pending</MenuItem>
//                         <MenuItem value="completed">Completed</MenuItem>
//                         <MenuItem value="failed">Failed</MenuItem>
//                         <MenuItem value="refunded">Refunded</MenuItem>
//                         <MenuItem value="expired">Expired</MenuItem>
//                       </Select>
//                     </FormControl>
//                   </Grid>
//                   <Grid item xs={12} sm={4}>
//                     <TextField
//                       fullWidth
//                       size="small"
//                       type="date"
//                       label="Start Date"
//                       value={dateRange.startDate}
//                       onChange={(e) => setDateRange({ ...dateRange, startDate: e.target.value })}
//                       InputLabelProps={{ shrink: true }}
//                     />
//                   </Grid>
//                   <Grid item xs={12} sm={4}>
//                     <TextField
//                       fullWidth
//                       size="small"
//                       type="date"
//                       label="End Date"
//                       value={dateRange.endDate}
//                       onChange={(e) => setDateRange({ ...dateRange, endDate: e.target.value })}
//                       InputLabelProps={{ shrink: true }}
//                     />
//                   </Grid>
//                 </Grid>
//               )}

//               {!selectedDriver ? (
//                 <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
//                   Please select a driver to view their recharge history
//                 </Typography>
//               ) : filteredHistory.length === 0 ? (
//                 <Box sx={{ textAlign: 'center', py: 4 }}>
//                   <Receipt sx={{ fontSize: 48, color: 'text.secondary', mb: 2 }} />
//                   <Typography variant="body1" color="text.secondary">
//                     No recharge records found for this driver
//                   </Typography>
//                   <Typography variant="body2" color="text.secondary">
//                     Try adjusting your filters or check back later
//                   </Typography>
//                 </Box>
//               ) : (
//                 <>
//                   <TableContainer component={Paper} sx={{ mt: 2 }}>
//                     <Table>
//                       <TableHead>
//                         <TableRow>
//                           <TableCell>Date & Time</TableCell>
//                           <TableCell>Amount</TableCell>
//                           <TableCell>Plan Type</TableCell>
//                           <TableCell>Validity</TableCell>
//                           <TableCell>Status</TableCell>
//                           <TableCell>Actions</TableCell>
//                         </TableRow>
//                       </TableHead>
//                       <TableBody>
//                         {filteredHistory.map((recharge) => (
//                           <TableRow key={recharge.id}>
//                             <TableCell>
//                               {new Date(recharge.created_at).toLocaleString()}
//                             </TableCell>
//                             <TableCell>
//                               <Typography fontWeight="bold" color="primary">
//                                 {formatCurrency(recharge.amount)}
//                               </Typography>
//                             </TableCell>
//                             <TableCell>
//                               <Chip 
//                                 label={getPlanTypeLabel(recharge.plan_type)} 
//                                 size="small" 
//                                 variant="outlined"
//                               />
//                             </TableCell>
//                             <TableCell>
//                               <Typography variant="caption" display="block">
//                                 From: {formatDate(recharge.start_date)}
//                               </Typography>
//                               <Typography variant="caption" display="block">
//                                 To: {formatDate(recharge.end_date)}
//                               </Typography>
//                             </TableCell>
//                             <TableCell>{getStatusChip(recharge.status)}</TableCell>
//                             <TableCell>
//                               <Button
//                                 size="small"
//                                 variant="outlined"
//                                 startIcon={<Receipt />}
//                                 onClick={() => handleViewDetails(recharge)}
//                                 sx={{ color: '#000' }}
//                               >
//                                 Details
//                               </Button>
//                             </TableCell>
//                           </TableRow>
//                         ))}
//                       </TableBody>
//                     </Table>
//                   </TableContainer>
                  
//                   {/* Pagination */}
//                   {pagination.totalPages > 1 && (
//                     <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
//                       <Pagination
//                         count={pagination.totalPages}
//                         page={page}
//                         onChange={handlePageChange}
//                         color="primary"
//                       />
//                     </Box>
//                   )}
//                 </>
//               )}
//             </CardContent>
//           </Card>
//         </Grid>
//       </Grid>

//       {/* Recharge Details Dialog */}
//       <Dialog
//         open={openDetailsDialog}
//         onClose={handleCloseDetailsDialog}
//         maxWidth="sm"
//         fullWidth
//       >
//         <DialogTitle sx={{ display: 'flex', alignItems: 'center' }}>
//           <Receipt sx={{ mr: 1, color: '#FFC107' }} />
//           Recharge Details
//         </DialogTitle>
//         <DialogContent>
//           {selectedRecharge && (
//             <Box sx={{ mt: 2 }}>
//               <Grid container spacing={2}>
//                 <Grid item xs={12}>
//                   <Typography variant="subtitle2" color="text.secondary">
//                     Recharge ID
//                   </Typography>
//                   <Typography variant="body1" sx={{ wordBreak: 'break-all' }}>
//                     {selectedRecharge.id}
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={6}>
//                   <Typography variant="subtitle2" color="text.secondary">
//                     Amount
//                   </Typography>
//                   <Typography variant="h6" color="primary">
//                     {formatCurrency(selectedRecharge.amount)}
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={6}>
//                   <Typography variant="subtitle2" color="text.secondary">
//                     Status
//                   </Typography>
//                   {getStatusChip(selectedRecharge.status)}
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Typography variant="subtitle2" color="text.secondary">
//                     Plan Type
//                   </Typography>
//                   <Typography variant="body2">
//                     {getPlanTypeLabel(selectedRecharge.plan_type)}
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={6}>
//                   <Typography variant="subtitle2" color="text.secondary">
//                     Start Date
//                   </Typography>
//                   <Typography variant="body2">
//                     {formatDate(selectedRecharge.start_date)}
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={6}>
//                   <Typography variant="subtitle2" color="text.secondary">
//                     End Date
//                   </Typography>
//                   <Typography variant="body2">
//                     {formatDate(selectedRecharge.end_date)}
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Typography variant="subtitle2" color="text.secondary">
//                     Created At
//                   </Typography>
//                   <Typography variant="body2">
//                     {new Date(selectedRecharge.created_at).toLocaleString()}
//                   </Typography>
//                 </Grid>
//                 {selectedRecharge.updated_at && selectedRecharge.updated_at !== selectedRecharge.created_at && (
//                   <Grid item xs={12}>
//                     <Typography variant="subtitle2" color="text.secondary">
//                       Last Updated
//                     </Typography>
//                     <Typography variant="body2">
//                       {new Date(selectedRecharge.updated_at).toLocaleString()}
//                     </Typography>
//                   </Grid>
//                 )}
//               </Grid>
//             </Box>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button
//             onClick={handleCloseDetailsDialog}
//             variant="contained"
//             sx={{
//               bgcolor: '#FFC107',
//               color: '#000',
//               '&:hover': {
//                 bgcolor: '#FFD54F',
//               },
//             }}
//           >
//             Close
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default DriverRechargeHistoryPage;


import React, { useState, useEffect, useMemo } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  Alert,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  IconButton,
  Tooltip,
  Pagination,
  Autocomplete,
  InputAdornment,
  Divider,
  Avatar,
  LinearProgress,
  Fade,
  Slide,
  Stack,
  useTheme,
  alpha,
} from '@mui/material';
import {
  Receipt,
  Refresh,
  FilterList,
  Download,
  Search,
  Person,
  Phone,
  Email,
  CalendarToday,
  AttachMoney,
  History,
  CheckCircle,
  Pending,
  Error,
  Cancel,
  TrendingUp,
  CreditCard,
  LocalOffer,
  Assignment,
} from '@mui/icons-material';
import apiService from '../services/apiService';

const DriverRechargeHistoryPage = () => {
  const theme = useTheme();
  const [drivers, setDrivers] = useState([]);
  const [selectedDriver, setSelectedDriver] = useState('');
  const [driverDetails, setDriverDetails] = useState(null);
  const [rechargeHistory, setRechargeHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [dateRange, setDateRange] = useState({
    startDate: '',
    endDate: '',
  });
  const [selectedRecharge, setSelectedRecharge] = useState(null);
  const [openDetailsDialog, setOpenDetailsDialog] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const [filteredHistory, setFilteredHistory] = useState([]);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 0,
    totalItems: 0,
    itemsPerPage: 10,
  });
  const [page, setPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    fetchDrivers();
  }, []);

  useEffect(() => {
    applyFilters();
  }, [rechargeHistory, filterStatus, dateRange]);

  const filteredDrivers = useMemo(() => {
    if (!searchQuery.trim()) return drivers;
    const query = searchQuery.toLowerCase().trim();
    return drivers.filter(driver => 
      driver.name?.toLowerCase().includes(query) ||
      driver.phone?.toLowerCase().includes(query) ||
      driver.email?.toLowerCase().includes(query) ||
      driver.id?.toLowerCase().includes(query)
    );
  }, [drivers, searchQuery]);

  const fetchDrivers = async () => {
    try {
      const response = await apiService.getDrivers({});
      if (response.success) {
        setDrivers(response.data || []);
      }
    } catch (err) {
      console.error('Error fetching drivers:', err);
      setError('Failed to load drivers');
    }
  };

  const handleDriverSelect = async (driverId) => {
    setSelectedDriver(driverId);
    setError('');
    setSuccess('');
    setFilterStatus('all');
    setDateRange({ startDate: '', endDate: '' });
    setTotalAmount(0);
    setPage(1);
    setIsLoading(true);

    if (!driverId) {
      setDriverDetails(null);
      setRechargeHistory([]);
      setPagination({
        currentPage: 1,
        totalPages: 0,
        totalItems: 0,
        itemsPerPage: 10,
      });
      setIsLoading(false);
      return;
    }

    try {
      const [driverResponse, historyResponse] = await Promise.all([
        apiService.getDriverDetails(driverId),
        apiService.getDriverRechargeHistory(driverId)
      ]);

      if (driverResponse.success) {
        setDriverDetails(driverResponse.data);
      }

      if (historyResponse.success) {
        const historyData = historyResponse.data?.history || [];
        setRechargeHistory(historyData);
        
        if (historyResponse.data?.pagination) {
          setPagination(historyResponse.data.pagination);
        }
        
        const total = historyData.reduce((sum, item) => sum + parseFloat(item.amount || 0), 0);
        setTotalAmount(total);
      }
    } catch (err) {
      setError('Failed to load recharge history');
      console.error('Error:', err);
    } finally {
      setIsLoading(false);
    }
  };

  const applyFilters = () => {
    let filtered = [...rechargeHistory];

    if (filterStatus !== 'all') {
      const statusMap = {
        'completed': ['active', 'completed'],
        'pending': ['pending'],
        'failed': ['failed'],
        'refunded': ['refunded'],
      };
      const validStatuses = statusMap[filterStatus] || [];
      filtered = filtered.filter(item => validStatuses.includes(item.status));
    }

    if (dateRange.startDate) {
      filtered = filtered.filter(item => 
        new Date(item.created_at) >= new Date(dateRange.startDate)
      );
    }
    if (dateRange.endDate) {
      filtered = filtered.filter(item => 
        new Date(item.created_at) <= new Date(dateRange.endDate)
      );
    }

    setFilteredHistory(filtered);
  };

  const handleRefresh = () => {
    if (selectedDriver) {
      handleDriverSelect(selectedDriver);
      setSuccess('Refreshed successfully');
      setTimeout(() => setSuccess(''), 3000);
    }
  };

  const handleViewDetails = (recharge) => {
    setSelectedRecharge(recharge);
    setOpenDetailsDialog(true);
  };

  const handleCloseDetailsDialog = () => {
    setOpenDetailsDialog(false);
    setSelectedRecharge(null);
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const handleDownloadReport = () => {
    const headers = ['Date', 'Amount', 'Plan Type', 'Status', 'Start Date', 'End Date'];
    const rows = filteredHistory.map(item => [
      new Date(item.created_at).toLocaleString(),
      `₹${parseFloat(item.amount || 0).toFixed(2)}`,
      item.plan_type || 'N/A',
      item.status,
      new Date(item.start_date).toLocaleDateString(),
      new Date(item.end_date).toLocaleDateString(),
    ]);

    const csvContent = [
      headers.join(','),
      ...rows.map(row => row.join(','))
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `recharge_history_${selectedDriver}_${new Date().toISOString().split('T')[0]}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const getStatusChip = (status) => {
    const statusConfig = {
      active: { label: 'Active', color: '#4CAF50', icon: <CheckCircle sx={{ fontSize: 16 }} /> },
      completed: { label: 'Completed', color: '#4CAF50', icon: <CheckCircle sx={{ fontSize: 16 }} /> },
      pending: { label: 'Pending', color: '#FF9800', icon: <Pending sx={{ fontSize: 16 }} /> },
      failed: { label: 'Failed', color: '#F44336', icon: <Error sx={{ fontSize: 16 }} /> },
      refunded: { label: 'Refunded', color: '#2196F3', icon: <Cancel sx={{ fontSize: 16 }} /> },
      expired: { label: 'Expired', color: '#9E9E9E', icon: <Cancel sx={{ fontSize: 16 }} /> },
    };
    const config = statusConfig[status] || statusConfig.pending;
    return (
      <Chip
        icon={config.icon}
        label={config.label}
        sx={{
          bgcolor: alpha(config.color, 0.12),
          color: config.color,
          fontWeight: 600,
          '& .MuiChip-icon': { color: config.color },
        }}
        size="small"
      />
    );
  };

  const getPlanTypeLabel = (planType) => {
    const planMap = {
      'admin_assigned_180d': 'Admin Assigned (180 Days)',
      'admin_assigned_90d': 'Admin Assigned (90 Days)',
      'admin_assigned_30d': 'Admin Assigned (30 Days)',
      'daily': 'Daily Plan',
      'weekly': 'Weekly Plan',
      'monthly': 'Monthly Plan',
    };
    return planMap[planType] || planType || 'N/A';
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  };

  const formatCurrency = (amount) => {
    const num = parseFloat(amount || 0);
    return `₹${num.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  };

  const getDriverLabel = (driver) => {
    if (!driver) return '';
    return `${driver.name}`;
  };

  const getStatusStats = () => {
    const stats = {
      total: rechargeHistory.length,
      active: 0,
      pending: 0,
      completed: 0,
      failed: 0,
    };
    rechargeHistory.forEach(item => {
      if (item.status === 'active' || item.status === 'completed') stats.completed++;
      else if (item.status === 'pending') stats.pending++;
      else if (item.status === 'failed') stats.failed++;
    });
    return stats;
  };

  const statusStats = getStatusStats();

  return (
    <Box sx={{ p: { xs: 2, md: 3 } }}>
      {/* Header Section */}
      <Box sx={{ mb: 4 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
          <Box>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 700,
                background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                mb: 1,
              }}
            >
              Driver Recharge History
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <History sx={{ fontSize: 18 }} />
              Search and select a driver to view their recharge history and transaction details
            </Typography>
          </Box>
          {selectedDriver && (
            <Stack direction="row" spacing={1}>
              <Button
                variant="outlined"
                startIcon={<Refresh />}
                onClick={handleRefresh}
                sx={{
                  borderRadius: 2,
                  borderColor: theme.palette.primary.main,
                  color: theme.palette.primary.main,
                }}
              >
                Refresh
              </Button>
              {filteredHistory.length > 0 && (
                <Button
                  variant="contained"
                  startIcon={<Download />}
                  onClick={handleDownloadReport}
                  sx={{
                    borderRadius: 2,
                    background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
                    '&:hover': {
                      transform: 'translateY(-2px)',
                      boxShadow: 3,
                    },
                    transition: 'all 0.3s ease',
                  }}
                >
                  Export CSV
                </Button>
              )}
            </Stack>
          )}
        </Box>
      </Box>

      {error && (
        <Fade in={!!error}>
          <Alert
            severity="error"
            sx={{ mb: 3, borderRadius: 2 }}
            onClose={() => setError('')}
          >
            {error}
          </Alert>
        </Fade>
      )}

      {success && (
        <Fade in={!!success}>
          <Alert
            severity="success"
            sx={{ mb: 3, borderRadius: 2 }}
            onClose={() => setSuccess('')}
          >
            {success}
          </Alert>
        </Fade>
      )}

      {isLoading && <LinearProgress sx={{ mb: 3, borderRadius: 2 }} />}

      <Grid container spacing={3}>
        {/* Left Panel - Driver Selection */}
        <Grid item xs={12} md={4}>
          {/* Driver Search Card */}
          <Card
            sx={{
              borderRadius: 3,
              boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
              border: `1px solid ${alpha(theme.palette.primary.main, 0.08)}`,
              overflow: 'visible',
            }}
          >
            <CardContent sx={{ p: 3 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                <Avatar sx={{ bgcolor: alpha(theme.palette.primary.main, 0.1), width: 32, height: 32 }}>
                  <Person sx={{ color: theme.palette.primary.main, fontSize: 20 }} />
                </Avatar>
                <Typography variant="h6" fontWeight={600}>
                  Select Driver
                </Typography>
              </Box>

              <Autocomplete
                value={drivers.find(d => d.id === selectedDriver) || null}
                onChange={(event, newValue) => {
                  handleDriverSelect(newValue?.id || '');
                  setSearchQuery('');
                }}
                inputValue={searchQuery}
                onInputChange={(event, newInputValue) => {
                  setSearchQuery(newInputValue);
                }}
                options={filteredDrivers}
                getOptionLabel={(option) => getDriverLabel(option)}
                isOptionEqualToValue={(option, value) => option.id === value?.id}
                loading={isLoading}
                filterOptions={(x) => x}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Search by name, phone, email..."
                    variant="outlined"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                        bgcolor: alpha(theme.palette.background.default, 0.6),
                      },
                    }}
                    InputProps={{
                      ...params.InputProps,
                      startAdornment: (
                        <>
                          <InputAdornment position="start">
                            <Search sx={{ color: theme.palette.text.secondary }} />
                          </InputAdornment>
                          {params.InputProps.startAdornment}
                        </>
                      ),
                    }}
                  />
                )}
                renderOption={(props, option) => (
                  <li {...props}>
                    <Box sx={{ width: '100%' }}>
                      <Typography variant="body1" fontWeight={600}>
                        {option.name}
                      </Typography>
                      <Stack direction="row" spacing={2} sx={{ mt: 0.5 }}>
                        <Typography variant="caption" color="text.secondary" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                          <Phone sx={{ fontSize: 14 }} /> {option.phone}
                        </Typography>
                        {option.email && (
                          <Typography variant="caption" color="text.secondary" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <Email sx={{ fontSize: 14 }} /> {option.email}
                          </Typography>
                        )}
                      </Stack>
                    </Box>
                  </li>
                )}
                noOptionsText={
                  searchQuery.trim() ? 'No drivers found matching your search' : 'Start typing to search drivers'
                }
                loadingText="Loading drivers..."
                sx={{ width: '100%' }}
              />

              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
                {drivers.length} drivers available {searchQuery && `(filtered: ${filteredDrivers.length})`}
              </Typography>

              {/* Driver Details */}
              {selectedDriver && driverDetails && (
                <Fade in={!!selectedDriver}>
                  <Box sx={{ mt: 3 }}>
                    <Divider sx={{ my: 2 }} />
                    <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 2 }}>
                      Driver Information
                    </Typography>
                    <Box
                      sx={{
                        p: 2,
                        borderRadius: 2,
                        bgcolor: alpha(theme.palette.primary.main, 0.04),
                        border: `1px solid ${alpha(theme.palette.primary.main, 0.08)}`,
                      }}
                    >
                      <Stack spacing={1.5}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Person sx={{ fontSize: 18, color: theme.palette.primary.main }} />
                          <Typography variant="body2">
                            <strong>{driverDetails.name}</strong>
                          </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Phone sx={{ fontSize: 18, color: theme.palette.text.secondary }} />
                          <Typography variant="body2">{driverDetails.phone}</Typography>
                        </Box>
                        {driverDetails.email && (
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Email sx={{ fontSize: 18, color: theme.palette.text.secondary }} />
                            <Typography variant="body2">{driverDetails.email}</Typography>
                          </Box>
                        )}
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Assignment sx={{ fontSize: 18, color: theme.palette.text.secondary }} />
                          <Chip
                            label={driverDetails.status || 'Active'}
                            size="small"
                            sx={{
                              bgcolor: alpha('#4CAF50', 0.12),
                              color: '#4CAF50',
                              fontWeight: 600,
                            }}
                          />
                        </Box>
                      </Stack>
                    </Box>
                  </Box>
                </Fade>
              )}
            </CardContent>
          </Card>

          {/* Summary Card */}
          {selectedDriver && rechargeHistory.length > 0 && (
            <Slide direction="up" in={!!selectedDriver} mountOnEnter unmountOnExit>
              <Card
                sx={{
                  mt: 3,
                  borderRadius: 3,
                  boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
                  border: `1px solid ${alpha(theme.palette.primary.main, 0.08)}`,
                }}
              >
                <CardContent sx={{ p: 3 }}>
                  <Typography variant="h6" fontWeight={600} gutterBottom>
                    Summary
                  </Typography>

                  <Grid container spacing={2} sx={{ mt: 1 }}>
                    <Grid item xs={6}>
                      <Box
                        sx={{
                          p: 1.5,
                          borderRadius: 2,
                          bgcolor: alpha(theme.palette.primary.main, 0.06),
                          textAlign: 'center',
                        }}
                      >
                        <Typography variant="caption" color="text.secondary">
                          Total Recharges
                        </Typography>
                        <Typography variant="h6" fontWeight={700} color="primary">
                          {rechargeHistory.length}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={6}>
                      <Box
                        sx={{
                          p: 1.5,
                          borderRadius: 2,
                          bgcolor: alpha(theme.palette.success.main, 0.06),
                          textAlign: 'center',
                        }}
                      >
                        <Typography variant="caption" color="text.secondary">
                          Total Amount
                        </Typography>
                        <Typography variant="h6" fontWeight={700} color="success.main">
                          {formatCurrency(totalAmount)}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>

                  <Stack direction="row" spacing={1} sx={{ mt: 2, flexWrap: 'wrap', gap: 1 }}>
                    <Box
                      sx={{
                        flex: 1,
                        p: 1,
                        borderRadius: 1.5,
                        bgcolor: alpha('#4CAF50', 0.08),
                        textAlign: 'center',
                        minWidth: 60,
                      }}
                    >
                      <Typography variant="caption" color="success.main" fontWeight={600}>
                        {statusStats.completed}
                      </Typography>
                      <Typography variant="caption" color="text.secondary" display="block">
                        Success
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        flex: 1,
                        p: 1,
                        borderRadius: 1.5,
                        bgcolor: alpha('#FF9800', 0.08),
                        textAlign: 'center',
                        minWidth: 60,
                      }}
                    >
                      <Typography variant="caption" color="warning.main" fontWeight={600}>
                        {statusStats.pending}
                      </Typography>
                      <Typography variant="caption" color="text.secondary" display="block">
                        Pending
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        flex: 1,
                        p: 1,
                        borderRadius: 1.5,
                        bgcolor: alpha('#F44336', 0.08),
                        textAlign: 'center',
                        minWidth: 60,
                      }}
                    >
                      <Typography variant="caption" color="error.main" fontWeight={600}>
                        {statusStats.failed}
                      </Typography>
                      <Typography variant="caption" color="text.secondary" display="block">
                        Failed
                      </Typography>
                    </Box>
                  </Stack>

                  {filteredHistory.length > 0 && (
                    <Box sx={{ mt: 2, p: 1.5, borderRadius: 2, bgcolor: alpha(theme.palette.info.main, 0.06) }}>
                      <Typography variant="caption" color="text.secondary">
                        Filtered: {filteredHistory.length} records | Amount:{' '}
                        {formatCurrency(
                          filteredHistory.reduce((sum, item) => sum + parseFloat(item.amount || 0), 0)
                        )}
                      </Typography>
                    </Box>
                  )}
                </CardContent>
              </Card>
            </Slide>
          )}
        </Grid>

        {/* Right Panel - History */}
        <Grid item xs={12} md={8}>
          <Card
            sx={{
              borderRadius: 3,
              boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
              border: `1px solid ${alpha(theme.palette.primary.main, 0.08)}`,
            }}
          >
            <CardContent sx={{ p: 3 }}>
              {/* Header */}
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Receipt sx={{ color: theme.palette.primary.main }} />
                  <Typography variant="h6" fontWeight={600}>
                    Recharge History
                  </Typography>
                  {selectedDriver && (
                    <Chip
                      label={`${filteredHistory.length} records`}
                      size="small"
                      sx={{
                        bgcolor: alpha(theme.palette.primary.main, 0.1),
                        color: theme.palette.primary.main,
                        fontWeight: 600,
                      }}
                    />
                  )}
                </Box>
              </Box>

              {/* Filters */}
              {selectedDriver && rechargeHistory.length > 0 && (
                <Paper
                  elevation={0}
                  sx={{
                    p: 2,
                    mb: 3,
                    bgcolor: alpha(theme.palette.background.default, 0.6),
                    borderRadius: 2,
                  }}
                >
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} sm={4}>
                      <FormControl fullWidth size="small">
                        <InputLabel>Status</InputLabel>
                        <Select
                          value={filterStatus}
                          onChange={(e) => setFilterStatus(e.target.value)}
                          label="Status"
                          sx={{ borderRadius: 1.5 }}
                        >
                          <MenuItem value="all">All Status</MenuItem>
                          <MenuItem value="active">Active</MenuItem>
                          <MenuItem value="pending">Pending</MenuItem>
                          <MenuItem value="completed">Completed</MenuItem>
                          <MenuItem value="failed">Failed</MenuItem>
                          <MenuItem value="refunded">Refunded</MenuItem>
                          <MenuItem value="expired">Expired</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <TextField
                        fullWidth
                        size="small"
                        type="date"
                        label="Start Date"
                        value={dateRange.startDate}
                        onChange={(e) => setDateRange({ ...dateRange, startDate: e.target.value })}
                        InputLabelProps={{ shrink: true }}
                        sx={{ borderRadius: 1.5 }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <TextField
                        fullWidth
                        size="small"
                        type="date"
                        label="End Date"
                        value={dateRange.endDate}
                        onChange={(e) => setDateRange({ ...dateRange, endDate: e.target.value })}
                        InputLabelProps={{ shrink: true }}
                        sx={{ borderRadius: 1.5 }}
                      />
                    </Grid>
                  </Grid>
                </Paper>
              )}

              {/* Content */}
              {!selectedDriver ? (
                <Box sx={{ textAlign: 'center', py: 8 }}>
                  <Avatar
                    sx={{
                      width: 80,
                      height: 80,
                      mx: 'auto',
                      mb: 2,
                      bgcolor: alpha(theme.palette.primary.main, 0.08),
                    }}
                  >
                    <Search sx={{ fontSize: 40, color: theme.palette.primary.main }} />
                  </Avatar>
                  <Typography variant="h6" color="text.secondary" gutterBottom>
                    Search for a Driver
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Use the search box to find and select a driver to view their recharge history
                  </Typography>
                </Box>
              ) : filteredHistory.length === 0 ? (
                <Box sx={{ textAlign: 'center', py: 8 }}>
                  <Receipt sx={{ fontSize: 64, color: theme.palette.text.disabled, mb: 2 }} />
                  <Typography variant="h6" color="text.secondary" gutterBottom>
                    No Recharge Records
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {rechargeHistory.length > 0
                      ? 'Try adjusting your filters to see more results'
                      : 'This driver has no recharge history yet'}
                  </Typography>
                </Box>
              ) : (
                <>
                  <TableContainer
                    component={Paper}
                    elevation={0}
                    sx={{
                      borderRadius: 2,
                      border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
                      overflowX: 'auto',
                    }}
                  >
                    <Table>
                      <TableHead>
                        <TableRow sx={{ bgcolor: alpha(theme.palette.primary.main, 0.04) }}>
                          <TableCell sx={{ fontWeight: 600 }}>Date & Time</TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>Amount</TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>Plan Type</TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>Validity</TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>Status</TableCell>
                          <TableCell sx={{ fontWeight: 600, textAlign: 'center' }}>Action</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {filteredHistory.map((recharge, index) => (
                          <TableRow
                            key={recharge.id}
                            sx={{
                              '&:hover': {
                                bgcolor: alpha(theme.palette.primary.main, 0.02),
                              },
                              transition: 'background-color 0.2s ease',
                            }}
                          >
                            <TableCell>
                              <Typography variant="body2" fontWeight={500}>
                                {new Date(recharge.created_at).toLocaleDateString('en-IN', {
                                  day: '2-digit',
                                  month: 'short',
                                  year: 'numeric',
                                })}
                              </Typography>
                              <Typography variant="caption" color="text.secondary">
                                {new Date(recharge.created_at).toLocaleTimeString('en-IN', {
                                  hour: '2-digit',
                                  minute: '2-digit',
                                })}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography variant="body2" fontWeight={700} color="primary">
                                {formatCurrency(recharge.amount)}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Chip
                                label={getPlanTypeLabel(recharge.plan_type)}
                                size="small"
                                variant="outlined"
                                sx={{ borderRadius: 1.5, fontWeight: 500 }}
                              />
                            </TableCell>
                            <TableCell>
                              <Typography variant="caption" display="block" color="text.secondary">
                                From: {formatDate(recharge.start_date)}
                              </Typography>
                              <Typography variant="caption" display="block" color="text.secondary">
                                To: {formatDate(recharge.end_date)}
                              </Typography>
                            </TableCell>
                            <TableCell>{getStatusChip(recharge.status)}</TableCell>
                            <TableCell align="center">
                              <Button
                                size="small"
                                variant="text"
                                startIcon={<Receipt sx={{ fontSize: 18 }} />}
                                onClick={() => handleViewDetails(recharge)}
                                sx={{
                                  color: theme.palette.primary.main,
                                  fontWeight: 600,
                                  '&:hover': {
                                    bgcolor: alpha(theme.palette.primary.main, 0.08),
                                  },
                                }}
                              >
                                Details
                              </Button>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>

                  {/* Pagination */}
                  {pagination.totalPages > 1 && (
                    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                      <Pagination
                        count={pagination.totalPages}
                        page={page}
                        onChange={handlePageChange}
                        color="primary"
                        sx={{
                          '& .MuiPaginationItem-root': {
                            borderRadius: 1.5,
                          },
                        }}
                      />
                    </Box>
                  )}
                </>
              )}
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Recharge Details Dialog */}
      <Dialog
        open={openDetailsDialog}
        onClose={handleCloseDetailsDialog}
        maxWidth="sm"
        fullWidth
        TransitionComponent={Slide}
        TransitionProps={{ direction: 'up' }}
        PaperProps={{
          sx: {
            borderRadius: 3,
            boxShadow: '0 16px 64px rgba(0,0,0,0.12)',
          },
        }}
      >
        <DialogTitle sx={{ pb: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Avatar sx={{ bgcolor: alpha(theme.palette.primary.main, 0.1) }}>
              <Receipt sx={{ color: theme.palette.primary.main }} />
            </Avatar>
            <Box>
              <Typography variant="h6" fontWeight={600}>
                Recharge Details
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Transaction Information
              </Typography>
            </Box>
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          {selectedRecharge && (
            <Grid container spacing={2.5}>
              <Grid item xs={12}>
                <Box
                  sx={{
                    p: 2,
                    borderRadius: 2,
                    bgcolor: alpha(theme.palette.primary.main, 0.04),
                    border: `1px solid ${alpha(theme.palette.primary.main, 0.08)}`,
                  }}
                >
                  <Typography variant="caption" color="text.secondary" display="block">
                    Recharge ID
                  </Typography>
                  <Typography variant="body2" fontWeight={500} sx={{ wordBreak: 'break-all' }}>
                    {selectedRecharge.id}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="caption" color="text.secondary" display="block">
                  Amount
                </Typography>
                <Typography variant="h5" fontWeight={700} color="primary">
                  {formatCurrency(selectedRecharge.amount)}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="caption" color="text.secondary" display="block">
                  Status
                </Typography>
                {getStatusChip(selectedRecharge.status)}
              </Grid>
              <Grid item xs={12}>
                <Typography variant="caption" color="text.secondary" display="block">
                  Plan Type
                </Typography>
                <Chip
                  label={getPlanTypeLabel(selectedRecharge.plan_type)}
                  variant="outlined"
                  sx={{ borderRadius: 1.5, fontWeight: 500 }}
                />
              </Grid>
              <Grid item xs={6}>
                <Typography variant="caption" color="text.secondary" display="block">
                  Start Date
                </Typography>
                <Typography variant="body2" fontWeight={500}>
                  {formatDate(selectedRecharge.start_date)}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="caption" color="text.secondary" display="block">
                  End Date
                </Typography>
                <Typography variant="body2" fontWeight={500}>
                  {formatDate(selectedRecharge.end_date)}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="caption" color="text.secondary" display="block">
                  Created At
                </Typography>
                <Typography variant="body2">
                  {new Date(selectedRecharge.created_at).toLocaleString()}
                </Typography>
              </Grid>
              {selectedRecharge.updated_at && selectedRecharge.updated_at !== selectedRecharge.created_at && (
                <Grid item xs={12}>
                  <Typography variant="caption" color="text.secondary" display="block">
                    Last Updated
                  </Typography>
                  <Typography variant="body2">
                    {new Date(selectedRecharge.updated_at).toLocaleString()}
                  </Typography>
                </Grid>
              )}
            </Grid>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2.5 }}>
          <Button
            onClick={handleCloseDetailsDialog}
            variant="contained"
            sx={{
              borderRadius: 2,
              px: 4,
              background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
              '&:hover': {
                transform: 'translateY(-2px)',
                boxShadow: 3,
              },
              transition: 'all 0.3s ease',
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default DriverRechargeHistoryPage;